import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Puts a new route at the top of the page, and honours a #fragment when one is
 * present so a contents link opened in a fresh tab lands on its section.
 *
 * Without this a client-side navigation keeps the previous scroll position,
 * which on a long legal page drops you into the middle of a document you have
 * not started reading.
 */
export default function ScrollToAnchor() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
